//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Fields.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../Fields/Fields.ProfileSolverOptionsBuilder.js";
import "../no/Expression.js";
let d=[[[0,"Cyclic",1,1],[1,"OrdinateOffset",0,"Expression",0],[1,"OrdinateScale",0,"Expression",0],[0,"OrdinateUnitType",1,"Unit",0],[1,"SlopeLeft",0,"Expression",1],[1,"SlopeRight",0,"Expression",1],[1,"SolverOptions",0,"Fields.ProfileSolverOptionsBuilder",0],[0,"XExtrapolation",1,1],[0,"XInterpolation",1,1],[1,"XOffset",0,"Expression",0],[1,"XScale",0,"Expression",0],[0,"XUnitType",1,"Unit",0]],[[["dataPoints"],"SetDataPointValues",{},1,0],[["dataPointCellIds","dataPointExpressions"],"SetDataPointExpressions",{},2,0],[["areMeasuresFixed"],"SetMeasuresFixed",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Fields.ManualInputProfileBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Fields.ManualInputProfileBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Fields.ManualInputProfileBuilder.Interpolation = Object.freeze({
    "Linear" : "Linear", "Akima" : "Akima", "Akima72" : "Akima72", "Cubic" : "Cubic"});

SPLM.Fields.ManualInputProfileBuilder.Extrapolation = Object.freeze({
    "Linear" : "Linear", "Parabolic" : "Parabolic"});

SPLM.Fields.ManualInputProfileBuilder.CyclicType = Object.freeze({
    "None" : "None", "XOnly" : "XOnly"});

export default SPLM;